import { render, staticRenderFns } from "./CrewEdit.vue?vue&type=template&id=3ddc839c"
import script from "./CrewEdit.vue?vue&type=script&lang=js"
export * from "./CrewEdit.vue?vue&type=script&lang=js"
import style0 from "./CrewEdit.vue?vue&type=style&index=0&id=3ddc839c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports